// extracted by mini-css-extract-plugin
export default {"container":"styles_container__H1aGt","maxWidthContainer":"styles_maxWidthContainer__kVIBb","card":"styles_card__BxLCF","rating":"styles_rating__N2BQh"};